import clx from 'classnames';
import type React from 'react';
import styled from 'styled-components';

const FooterTopSpace = styled.div`
  margin-top: 24px;
  &.has-static-footer {
    margin-top: 6px;
  }
  &.has-sider {
    margin-top: 0px;
    display: none;
  }
`;

export interface IFooterContainerProps {
  children: React.ReactNode;
  /**  Per gestire la larghezza del footer */
  hasSider?: boolean;
  /**  Per rimuovere il margine superiore se mostrato lo static footer */
  hasStaticFooter?: boolean;
}

/**
 * Container del footer dell'applicativo Admin e Backoffice.
 */
export function FooterContainer(props: IFooterContainerProps) {
  return (
    <>
      <FooterTopSpace
        className={clx({
          'has-static-footer': props.hasStaticFooter,
          'has-sider': props.hasSider,
        })}
      />
      {props.children}
    </>
  );
}
